import { AfterViewInit, Component, OnDestroy } from '@angular/core';
// import { companyStrings } from './companystrings'

@Component({
  selector: 'app-website-companytest',
  templateUrl: './website-companytest.component.html',
  styleUrls: ['./website-companytest.component.scss']
})
export class WebsiteCompanytestComponent implements AfterViewInit, OnDestroy {

  // logourl = companyStrings;
  imgindex: number = 0;
  logourl = [
    [{
      imgsrc: 'Charter_Logo.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'Ciena.webp',
      color: 'card-body purple'
    },
    {
      imgsrc: 'Virgin_Media.webp',
      color: 'card-body green'
    },
    {
      imgsrc: 'corporate-Comcast-Logo-min.webp',
      color: 'card-body blue'
    }],
    [{
      imgsrc: 'juniper-networks-white.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'commscope-logo.webp',
      color: 'card-body green'
    },
    {
      imgsrc: 'VZ-White.webp',
      color: 'card-body green'
    },
    {
      imgsrc: 'AT&T.webp',
      color: 'card-body blue'
    }],
    [{
      imgsrc: 'colt_logo_white.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'nokia_logo_blue.webp',
      color: 'card-body purple'
    },
    {
      imgsrc: 'Ericsson-logo.webp',
      color: 'card-body green'
    },
    {
      imgsrc: 'fujitsu.webp',
      color: 'card-body blue'
    }],
    [{
      imgsrc: 'altice_logo.webp',
      color: 'card-body purple'
    },
    {
      imgsrc: 'Microsoft.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'Cox.webp',
      color: 'card-body blue'
    },
    {
      imgsrc: 'Infinera.webp',
      color: 'card-body green'
    }],
    [{
      imgsrc: 'ADVA.webp',
      color: 'card-body purple'
    },
    {
      imgsrc: 'Arista.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'CenturyLink.webp',
      color: 'card-body blue'
    },
    {
      imgsrc: 'Cisco_copy.webp',
      color: 'card-body green'
    }],
    [{
      imgsrc: 'Google.webp',
      color: 'card-body purple'
    },
    {
      imgsrc: 'Intel-Logo.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'Motorola.webp',
      color: 'card-body blue'
    },
    {
      imgsrc: 'Orange_transparent.webp',
      color: 'card-body purple'
    }],
    [{
      imgsrc: 'frontier_transparent.webp',
      color: 'card-body green'
    },
    {
      imgsrc: 'LM_logo_grey.webp',
      color: 'card-body purple'
    },
    {
      imgsrc: 'Mediacom_transparent.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'Voo_Logo.webp',
      color: 'card-body blue'
    }],
    [{
      imgsrc: 'Raytheon_transparent.webp',
      color: 'card-body green'
    },
    {
      imgsrc: 'Segra_transparent.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'Sparklight_transparent.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'WOW_Logo_only.webp',
      color: 'card-body blue'
    }],
    [{
      imgsrc: 'PG&E-1.webp',
      color: 'card-body green'
    },
    {
      imgsrc: 'Ritter_Comm.webp',
      color: 'card-body purple'
    },
    {
      imgsrc: 'Great_Plains_Comm.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'SEFNCO_Comm.webp',
      color: 'card-body green'
    }],
    [{
      imgsrc: 'JCOM.webp',
      color: 'card-body purple'
    },
    {
      imgsrc: 'Deutsche_Telecom.webp',
      color: 'card-body gray'
    },
    {
      imgsrc: 'Claro.webp',
      color: 'card-body blue'
    },
    {
      imgsrc: 'Rogers.webp',
      color: 'card-body green'
    }],
    [{
      imgsrc: 'Shaw.webp',
      color: 'card-body purple'
    },
    {
      imgsrc: 'NTT.webp',
      color: 'card-body gray'
    }],
  ];
item: any = this.logourl[0];
  carousel2 = [];
  private imgIntervalId: any;
  constructor() { }

  ngAfterViewInit(): void {
    this.updateIMG();
    // while (this.logourl.length > 0){
    //   this.carousel2.push(this.logourl.splice(0, 4));
    // }
    // console.log(this.carousel2);
    
  }
  updateIMG() {
    // console.log('imgindex', this.imgindex);
    
    this.imgIntervalId = setInterval(() => {
      this.imgindex = (this.imgindex + 1) % 11;
      this.item = this.logourl[this.imgindex];
      // console.log('update index', this.imgindex);
      // this.imgurl = this.images[this.imgindex].src;
      // this.cd.detectChanges();
      console.log(this.item);
      
    }, 6000); // 8000 milliseconds = 8 seconds
  }


  // getImageWidth(path: string): number {
  //   // console.log(path);
    
  //   const img = new Image();
  //   img.src = './assets/images/customerlogos/webp/' + path;
  //   console.log(path ,img.naturalWidth,img.naturalHeight);
  //   if(img.naturalWidth > 0){
  //     return img.naturalWidth;
  //   }
  // }

  // getImageHeight(path: string): number {
  //   const img = new Image();
  //   img.src = './assets/images/customerlogos/webp/' + path;
  //   if(img.naturalHeight > 0){
  //     return img.naturalHeight;
  //   }
  // }
  ngOnDestroy(): void {
    if (this.imgIntervalId) {
      clearInterval(this.imgIntervalId);
    }
  }
}
